import { Box } from "@mittwald/flow-components/dist/components/Box";
import { ColumnLayout } from "@mittwald/flow-components/dist/components/ColumnLayout";
import { H3 } from "@mittwald/flow-components/dist/components/H3";
import SelectBox from "@mittwald/flow-components/dist/components/SelectBox";
import { TextField } from "@mittwald/flow-components/dist/components/TextField";
import { TextLink } from "@mittwald/flow-components/dist/components/TextLink";
import { TextWithIconLayout } from "@mittwald/flow-components/dist/components/TextWithIconLayout";
import { isDomain } from "@mittwald/flow-lib/dist/validation/domain";
import type { FC } from "react";
import React, { useEffect } from "react";
import { List } from "@mittwald/flow-components/dist/components/List";
import { useFormContext } from "@mittwald/flow-components/dist/components/Form";
import { useFieldArray } from "react-hook-form";
import { iconPlus } from "@mittwald/flow-icons/dist/plus";
import type { RelocationFormData } from "../../../../RelocationRequestWidget";
import { StepHeaderItem } from "../../../StepHeaderItem";

export const DomainList: FC = () => {
  const form = useFormContext<RelocationFormData>();
  const { fields, remove, insert } = useFieldArray({
    control: form.control,
    name: "domains",
  });

  const domainListVisible = form.watch("domainTransfer") === "domainTransfer";

  useEffect(() => {
    if (domainListVisible && fields.length === 0) {
      insert(0, {
        name: "",
        authCode: "",
      });
    }
  }, [domainListVisible]);

  return (
    <React.Fragment>
      <StepHeaderItem
        description="domainTransfer.description"
        headline="domainTransfer.headline"
      />

      <Box _my="m">
        <SelectBox
          name="domainTransfer"
          options={[
            {
              title: "noDomainTransfer",
              value: "noDomainTransfer",
            },
            {
              title: "domainTransfer",
              value: "domainTransfer",
            },
          ]}
        />
      </Box>

      {domainListVisible && (
        <React.Fragment>
          <Box
            _display="flex"
            _flexDirection="row"
            _justifyContent="space-between"
            _my="m"
          >
            <H3 i18n="domainList.headline" />
            <TextWithIconLayout icon={iconPlus}>
              <TextLink
                _alignSelf="flex-start"
                action={() =>
                  insert(0, {
                    name: "",
                    authCode: "",
                  })
                }
                i18n="createNewDomainEntry"
              />
            </TextWithIconLayout>
          </Box>
          <ColumnLayout>
            {fields.map((item, index) => (
              <List.HeavyItem
                closeAction={() => {
                  remove(index);
                }}
                key={item.id}
              >
                <Box
                  _display="flex"
                  _flexDirection="row"
                  _itemGap="m"
                  _width="100%"
                >
                  <TextField
                    _width="100%"
                    label="domainName"
                    name={`domains.${index}.name`}
                    rules={{
                      required: true,
                      validate: {
                        validDomain: (value: string): boolean =>
                          isDomain(value),
                      },
                    }}
                  />
                  <TextField
                    _width="100%"
                    label="domainAuthCode"
                    name={`domains.${index}.authCode`}
                    rules={{
                      required: true,
                    }}
                  />
                </Box>
              </List.HeavyItem>
            ))}
          </ColumnLayout>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};
